<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Wristband Marketing Settings Page
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Wristband Settings",
      items: [],
      wristbandconfig: {
        maxprice: {
          active: false,
          device: [],
          systemtype: "1",
        },
      },
      wristbandextend: {
        saveanonymous: false,
        autoaddgroupo: false,
      },
      userinfo: null,
      devicelist: [],
      wristbandgetloading: false,
      wristbandloading: false,
      wristbandgetextloading: false,
      wristband_ext_loading: false,
      actionlimit: {
        status: false,
        time: "08:00:00",
      },
      limitloading: false,
      timelimit: {
        status: false,
        time: 20,
        value: 250,
      },
      settingtag: "wristband",
      only_wristband: [],
      systemtypeOptions: [
        { label: this.$t("marketing.wristband.simple") || "简单模式", value: "1" },
      ],
    };
  },
  mounted() {
    this.title = this.$t("menuitems.marketing.wristband.text");
    this.items = [
      {
        text: this.$t("menuitems.marketing.text"),
        href: "/",
      },
      {
        text: this.$t("menuitems.marketing.wristband.text"),
        active: true,
      },
    ];

    try {
      this.userinfo = JSON.parse(localStorage.getItem("user"));
      if (!this.userinfo) {
        this.$message.error(this.$t("global.errors.loginrequired"));
        this.$router.push({ name: "login" });
        return;
      }
    } catch (error) {
      console.error("解析用户信息失败:", error);
      this.$message.error(this.$t("global.errors.loginrequired"));
      this.$router.push({ name: "login" });
      return;
    }

    this.getdevicelist();
    this.getwristbandsetting();
    this.getwristbandextsetting();
    this.getwristbandlimit();
    this.gettimelimit();
  },
  methods: {
    getwristbandsetting() {
      this.wristbandgetloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getwristbandsetting",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.wristbandgetloading = false;
          if (response.data.status === 200 && response.data.config) {
            this.wristbandconfig = {
              maxprice: {
                active: response.data.config.maxprice?.active || false,
                device: response.data.config.maxprice?.device || [],
                systemtype: response.data.config.maxprice?.systemtype || "1",
              },
            };
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.wristbandgetloading = false;
          console.error("获取手环设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getwristbandextsetting() {
      this.wristbandgetextloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getwristband_ext_setting",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.wristbandgetextloading = false;
          if (response.data.status === 200 && response.data.config) {
            this.wristbandextend = {
              saveanonymous: response.data.config.saveanonymous || false,
              autoaddgroupo: response.data.config.autoaddgroupo || false,
            };
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.wristbandgetextloading = false;
          console.error("获取手环扩展设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getwristbandlimit() {
      this.limitloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getwristband_limit",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.limitloading = false;
          if (response.data.status === 200 && response.data.config) {
            this.actionlimit = {
              status: response.data.config.status || false,
              time: response.data.config.time || "08:00:00",
            };
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.limitloading = false;
          console.error("获取手环限制设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    gettimelimit() {
      this.limitloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getwristband_timelimit",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.limitloading = false;
          if (response.data.status === 200 && response.data.config) {
            this.timelimit = {
              status: response.data.config.status || false,
              time: response.data.config.time || 20,
              value: response.data.config.value || 250,
            };
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
          }
        })
        .catch((error) => {
          this.limitloading = false;
          console.error("获取时间限制设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    getdevicelist() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "getdevicelist",
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (response.data.status === 200 || response.data.data) {
            this.devicelist = response.data.data || [];
          }
        })
        .catch((error) => {
          console.error("获取设备列表失败:", error);
          this.devicelist = [];
        });
    },
    save() {
      this.wristbandloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "savewristbandsetting",
            config: this.wristbandconfig.maxprice,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.wristbandloading = false;
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.wristbandloading = false;
          console.error("保存手环设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    save_extend() {
      this.wristband_ext_loading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "savewristband_ext_setting",
            config: this.wristbandextend,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.wristband_ext_loading = false;
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.wristband_ext_loading = false;
          console.error("保存手环扩展设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    save_limit() {
      this.limitloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "savewristband_limit",
            config: this.actionlimit,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.limitloading = false;
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
            // 如果保存成功，重新获取时间限制设置以更新状态
            this.gettimelimit();
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.limitloading = false;
          console.error("保存手环限制设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    save_timelimit() {
      this.limitloading = true;
      this.$axios
        .post(
          this.apiuri,
          {
            action: "savewristband_timelimit",
            config: this.timelimit,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          this.limitloading = false;
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
            // 如果保存成功，重新获取限制设置以更新状态
            this.getwristbandlimit();
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          this.limitloading = false;
          console.error("保存时间限制设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
    save_only_wristband() {
      this.$axios
        .post(
          this.apiuri,
          {
            action: "saveonlywristband",
            config: this.only_wristband,
          },
          {
            headers: { Openid: this.userinfo.openid },
          }
        )
        .then((response) => {
          if (response.data.status === 200) {
            this.$message({
              message: response.data.msg || this.$t("global.success"),
              type: "success",
            });
          } else {
            this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
          }
        })
        .catch((error) => {
          console.error("保存仅手环设置失败:", error);
          this.$message.error(this.$t("global.errors.network"));
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>
              <i class="el-icon-setting"></i>
              {{ $t("menuitems.marketing.wristband.text") }}
            </span>
          </div>
          <el-tabs v-model="settingtag" type="card">
            <!-- 畅饮设置 -->
            <el-tab-pane :label="$t('marketing.wristband.drink')" name="wristband">
              <el-card v-loading="wristbandgetloading" style="margin-top: 20px">
                <el-form 
                  ref="wristbandForm" 
                  :model="wristbandconfig.maxprice" 
                  label-width="150px"
                  label-position="left"
                >
                  <el-form-item :label="$t('marketing.wristband.active')">
                    <el-switch 
                      v-model="wristbandconfig.maxprice.active"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.active_tip") || "开启或关闭畅饮功能" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item 
                    :label="$t('marketing.wristband.systemmode')"
                    v-if="wristbandconfig.maxprice.active"
                  >
                    <el-select 
                      v-model="wristbandconfig.maxprice.systemtype"
                      :placeholder="$t('marketing.wristband.systemmode')"
                      style="width: 100%"
                      filterable
                    >
                      <el-option 
                        v-for="option in systemtypeOptions"
                        :key="option.value"
                        :label="option.label" 
                        :value="option.value"
                      ></el-option>
                    </el-select>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.systemmode_tip") || "选择系统模式" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="save" 
                      :loading="wristbandloading"
                      icon="el-icon-check"
                    >
                      {{ $t("global.button.save") }}
                    </el-button>
                    <el-button 
                      @click="getwristbandsetting"
                      icon="el-icon-refresh"
                    >
                      {{ $t("global.button.cancel") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </el-tab-pane>

            <!-- 扩展设置 -->
            <el-tab-pane :label="$t('marketing.wristband.extend')" name="extend">
              <el-card v-loading="wristbandgetextloading" style="margin-top: 20px">
                <el-form 
                  ref="extendForm" 
                  :model="wristbandextend" 
                  label-width="150px"
                  label-position="left"
                >
                  <el-form-item :label="$t('marketing.wristband.saveanonymous')">
                    <el-switch 
                      v-model="wristbandextend.saveanonymous"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.saveanonymous_tip") || "保存匿名用户信息" }}</small>
                    </div>
                  </el-form-item>

                  <el-form-item :label="$t('marketing.wristband.autoaddgroupo')">
                    <el-switch 
                      v-model="wristbandextend.autoaddgroupo"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <el-alert 
                      :title="$t('marketing.wristband.autoaddgroupotip')" 
                      type="warning" 
                      :closable="false"
                      show-icon
                      style="margin-top: 10px"
                    ></el-alert>
                  </el-form-item>

                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="save_extend" 
                      :loading="wristband_ext_loading"
                      icon="el-icon-check"
                    >
                      {{ $t("global.button.save") }}
                    </el-button>
                    <el-button 
                      @click="getwristbandextsetting"
                      icon="el-icon-refresh"
                    >
                      {{ $t("global.button.cancel") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </el-tab-pane>

            <!-- 时间限制 -->
            <el-tab-pane :label="$t('marketing.wristband.times')" name="timelimit">
              <el-card v-loading="limitloading" style="margin-top: 20px">
                <el-form 
                  ref="timelimitForm" 
                  :model="timelimit" 
                  label-width="150px"
                  label-position="left"
                >
                  <el-form-item :label="$t('marketing.wristband.active')">
                    <el-switch 
                      v-model="timelimit.status"
                      :disabled="actionlimit.status === true"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip" v-if="actionlimit.status === true">
                      <small class="text-muted">{{ $t("marketing.wristband.timelimit_disabled_tip") || "时间限制和动作限制不能同时启用" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item 
                    :label="$t('marketing.wristband.limittime')"
                    v-if="timelimit.status"
                  >
                    <el-input-number 
                      v-model="timelimit.time" 
                      :min="1" 
                      :max="60" 
                      :step="1"
                      :precision="0"
                    ></el-input-number>
                    <span style="margin-left: 10px">{{ $t("marketing.wristband.minute") }}</span>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.limittime_tip") || "设置时间限制（分钟）" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item 
                    :label="$t('marketing.wristband.limitvalue')"
                    v-if="timelimit.status"
                  >
                    <el-input-number 
                      v-model="timelimit.value" 
                      :min="1" 
                      :max="6000" 
                      :step="50"
                      :precision="0"
                    ></el-input-number>
                    <span style="margin-left: 10px">ML</span>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.limitvalue_tip") || "设置限制值（毫升）" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="save_timelimit"
                      :loading="limitloading"
                      icon="el-icon-check"
                    >
                      {{ $t("global.button.save") }}
                    </el-button>
                    <el-button 
                      @click="gettimelimit"
                      icon="el-icon-refresh"
                    >
                      {{ $t("global.button.cancel") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </el-tab-pane>

            <!-- 动作限制 -->
            <el-tab-pane :label="$t('marketing.wristband.limit')" name="beerlimttype2">
              <el-card v-loading="limitloading" style="margin-top: 20px">
                <el-form 
                  ref="limitForm" 
                  :model="actionlimit" 
                  label-width="150px"
                  label-position="left"
                >
                  <el-form-item :label="$t('marketing.wristband.active')">
                    <el-switch 
                      v-model="actionlimit.status"
                      :disabled="timelimit.status === true"
                      :active-text="$t('global.text.yes')"
                      :inactive-text="$t('global.text.no')"
                    ></el-switch>
                    <div class="form-item-tip" v-if="timelimit.status === true">
                      <small class="text-muted">{{ $t("marketing.wristband.actionlimit_disabled_tip") || "动作限制和时间限制不能同时启用" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item 
                    :label="$t('marketing.wristband.resettime')"
                    v-if="actionlimit.status"
                  >
                    <el-time-picker 
                      v-model="actionlimit.time" 
                      :picker-options="{
                        selectableRange: '00:00:00 - 23:59:59'
                      }" 
                      value-format="HH:mm:ss" 
                      :placeholder="$t('marketing.wristband.selecttime')"
                      style="width: 100%"
                    ></el-time-picker>
                    <div class="form-item-tip">
                      <small class="text-muted">{{ $t("marketing.wristband.resettime_tip") || "设置重置时间" }}</small>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button 
                      type="primary" 
                      @click="save_limit"
                      :loading="limitloading"
                      icon="el-icon-check"
                    >
                      {{ $t("global.button.save") }}
                    </el-button>
                    <el-button 
                      @click="getwristbandlimit"
                      icon="el-icon-refresh"
                    >
                      {{ $t("global.button.cancel") }}
                    </el-button>
                  </el-form-item>
                </el-form>
              </el-card>
            </el-tab-pane>
          </el-tabs>
        </el-card>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.clearfix {
  font-weight: 500;
}

.clearfix i {
  margin-right: 5px;
}

.form-item-tip {
  margin-top: 5px;
}
</style>